import { useAuth } from '@/contexts/AuthContext';
import { usePermissions } from '@/hooks/usePermissions';
import { useLocation } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

/**
 * مكون لعرض معلومات تشخيصية للمصادقة والصلاحيات
 * يستخدم في بيئة التطوير لتشخيص مشاكل الصلاحيات
 */
export function AuthDebugInfo() {
  const {
    user,
    loading
  } = useAuth();
  const {
    canAccessRoute,
    hasPermission
  } = usePermissions();
  const location = useLocation();
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  return;
}